import { ArticleParagraph2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IPriceQualityBarProps {
  estimationLowerBound: React.ReactChild;
  estimationUpperBound: React.ReactChild;
  offerPrice: React.ReactChild;
  labelPos: number;
}

export const PriceQualityBar: React.FC<IPriceQualityBarProps> = props => {
  const { estimationLowerBound, estimationUpperBound, offerPrice, labelPos } = props;
  const labelRef = React.useRef<HTMLSpanElement>(null);
  const [labelWidth, setLabelWidth] = React.useState<number>(0);

  React.useEffect(() => {
    if (labelRef.current) {
      const { width } = labelRef.current.getBoundingClientRect();
      setLabelWidth(width);
    }
  }, []);

  return (
    <div>
      <div className={styles['titles']}>
        <ArticleParagraph2 color="gray60_100">Низкая</ArticleParagraph2>
        <ArticleParagraph2 color="gray60_100">Хорошая цена</ArticleParagraph2>
        <ArticleParagraph2 color="gray60_100">Высокая</ArticleParagraph2>
      </div>
      <div className={styles['bar']}>
        <div className={styles['fill']}>
          <span
            ref={labelRef}
            className={styles['label']}
            style={{ left: `clamp(${labelWidth / 2}px, ${labelPos * 100}%, calc(100% - ${labelWidth / 2}px))` }}
          >
            {offerPrice}
          </span>
        </div>
      </div>
      <div className={styles['values']}>
        <div className={styles['price_start']}>
          <ArticleParagraph2>{estimationLowerBound}</ArticleParagraph2>
        </div>
        <div className={styles['price_end']}>
          <ArticleParagraph2>{estimationUpperBound}</ArticleParagraph2>
        </div>
      </div>
    </div>
  );
};

PriceQualityBar.displayName = 'PriceQualityBar';
